<template>
  <v-card class="mb-2 d-flex align-center" outlined>
    <v-tabs :value="tab" class="flex-grow-0 tab-styles" show-arrows @change="onChangeTab">
      <v-tab v-for="(country, index) in countriesFormatted" :key="index">
        {{ country }}
        <v-icon v-if="index !== 0 && !isDisabled" class="ml-1" small @click="onClickDelete(index)">clear</v-icon>
      </v-tab>
    </v-tabs>
    <div class="d-flex align-center pr-2">
      <autocomplete-input
        v-model="countryToAdd"
        :disabled="isDisabled"
        :items="availableCountries"
        class="input-styles"
        label="Add Country"
        hide-details
        outlined
      />
      <v-btn
        :disabled="!countryToAdd || isDisabled"
        class="ml-2 px-1"
        color="primary"
        min-width="0"
        depressed
        @click="onClickAddCountry"
      >
        <v-icon>add</v-icon>
      </v-btn>
    </div>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'

import AutocompleteInput from '@/components/forms/autocomplete-input'

import DataModification from '@/mixins/data-modification'

export default {
  name: 'GeoTabs',
  components: {
    AutocompleteInput,
  },
  mixins: [DataModification],
  model: {
    prop: 'tab',
  },
  props: {
    countries: {
      type: Array,
      required: true,
    },
    tab: {
      type: Number,
      required: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    countryToAdd: '',
  }),
  computed: {
    ...mapGetters('options', ['getItemsForOption']),
    availableCountries() {
      return this.getItemsForOption('countries').filter(({ value }) => !this.countries.includes(value))
    },
    countriesFormatted() {
      return this.countries.map(country => this.formatDiffKey('countries', country))
    },
  },
  methods: {
    onChangeTab(tab) {
      this.$emit('input', tab)
    },
    onClickAddCountry() {
      this.$emit('add', this.countryToAdd)
      this.countryToAdd = ''
    },
    onClickDelete(tab) {
      if (this.isDisabled) return
      this.$emit('delete', this.countries[tab])
      this.$emit('input', 0)
    },
  },
}
</script>

<style lang="scss" scoped>
.tab-styles {
  min-width: 0;
}

.input-styles {
  min-width: 200px;
}
</style>
